"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLegacyCookieName = getLegacyCookieName;
/* istanbul ignore file */
/**
 * Returns value of legacy language cookie.
 *
 * @param tenant
 * @returns
 */
function getLegacyCookieName(tenant) {
  return `${tenant}_website#lang`;
}